/* eslint-disable */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';
export const ExcelPreviewStyles = () => {
    const useClasses = makeStyles((theme) => ({
        dialogContent: {
            padding: '16px 24px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            height: '70vh',
            backgroundColor: '#ffffff',
        },
        tableContainer: {
            overflowX: 'auto',
            overflowY: 'auto',
            flex: 1,
            backgroundColor: '#ffffff',
            "& thead": {
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#f5f5f5",
            },
            "& tr": {
                "& th": {
                    padding: "10px 16px !important",
                    backgroundColor: "#f5f5f5",
                    fontFamily: "OpenSans-bold",
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                },
                "& td": {
                    padding: "10px 16px !important",
                    fontFamily: "OpenSans-semibold",
                    color: "#3c454f",
                    fontSize: "0.8rem",
                    backgroundColor: "#ffffff",
                    borderBottom: "1px solid #f0f0f0",
                },
            },
        },
        cellTruncate: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '200px',
        },
        rowHover: {
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        sheetTabActive: {
            color: '#1976d2',
            borderBottom: '2px solid #1976d2',
            fontFamily: 'OpenSans-bold',
            padding: '8px 16px',
            cursor: 'pointer',
        },
        sheetTabInactive: {
            color: '#5a6872',
            borderBottom: '2px solid transparent',
            padding: '8px 16px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#f5f5f5',
            },
        },
        paginationBar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '8px 0',
            fontFamily: 'OpenSans-semibold',
            fontSize: '0.875rem',
        },
        bottomBar: {
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#ffffff',
            padding: '8px 16px',
            zIndex: 2,
        },
        footerActions: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '12px 24px',
            gap: '12px',
            backgroundColor: '#ffffff',
        },
        horizontalScrollContainer: {
            overflowX: 'auto',
            width: '100%',
        },
        noDataMessage: {
            textAlign: 'center',
            width: '100%',
            padding: '40px 0',
            fontFamily: 'OpenSans-regular',
            fontSize: theme.typography.pxToRem(14),
            color: '#5a6872',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        readOnlyLabel: {
            color: '#9e9e9e',
            fontStyle: 'italic',
            fontSize: '0.875rem',
            marginLeft: '8px',
            fontFamily: 'OpenSans-regular',
        },
        readOnlyBadge: {
            backgroundColor: '#e0e0e0',
            color: '#616161',
            fontSize: '0.75rem',
            fontFamily: 'OpenSans-semibold',
            padding: '2px 10px',
            borderRadius: '12px',
            display: 'inline-block',
        },
        excelPreviewModal: {
            '& .MuiDialogTitle-root': {
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
            },
            '& .MuiDialogTitle-root > *': {
                display: 'inline',
            },
            '& .MuiDialogTitle-root::after': {
                content: '"Read Only"',
                backgroundColor: '#e0e0e0',
                color: '#616161',
                fontSize: '0.75rem',
                fontFamily: 'OpenSans-semibold',
                padding: '2px 10px',
                borderRadius: '12px',
                display: 'inline-block',
                verticalAlign: 'middle',
            },
        },
    }));
    const classes = useClasses();
    return classes;
}
